import { useContext } from "react";
import { useCompany } from "../../components/CompanyProvider/CompanyProvider";
import { createKlaviyoEvent, gaEvent, initializeGA, logReactPixel, logReactPixelPageView, datadogLog, gtmEvent, } from "./Logging-utils";
import { LoggingContext } from "../../components/LoggingContext/LoggingProvider";
export const useLogging = () => {
    const { buildVersion, environment, application, isLogRocketEnabled } = useContext(LoggingContext);
    const { keys, companyUsesKlaviyo } = useCompany();
    const pixelKey = keys === null || keys === void 0 ? void 0 : keys.find((key) => key.KeyName === "FacebookPixelId");
    const gaKey = keys === null || keys === void 0 ? void 0 : keys.find((key) => key.KeyName === "GtagKey");
    return {
        createKlaviyoEvent: createKlaviyoEvent(companyUsesKlaviyo),
        logReactPixel: logReactPixel(pixelKey),
        logReactPixelPageView: logReactPixelPageView(pixelKey),
        gaEvent: gaEvent(gaKey),
        initializeGA: initializeGA(gaKey),
        datadogLog: datadogLog(environment, buildVersion, application),
        gtmEvent,
        isLogRocketEnabled: isLogRocketEnabled,
    };
};
